import { routingConstants } from '../utils/types';

export default function routing(state = {}, action) {
  switch (action.type) {
  case routingConstants.SET_SIGN_END_ROUTE:
    return { ...state, signEndRoute: action.payload.signEndRoute };
  case routingConstants.SET_SIGN_END_ROUTE_ACTION:
    return {
      ...state,
      signEndRouteActionType: action.payload.type,
      signEndRouteActionParam: action.payload.param
    };
  case routingConstants.SET_SIGN_CANCEL_ROUTE:
    return { ...state, signCancelRoute: action.payload.signCancelRoute };
  case routingConstants.SET_PAYMENT_END_ROUTE:
    return { ...state, paymentEndRoute: action.payload.paymentEndRoute };
  case routingConstants.SET_PAYMENT_END_ROUTE_ACTION:
    return {
      ...state,
      paymentEndRouteActionType: action.payload.type,
      paymentEndRouteActionParam: action.payload.param
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/routingReducer.js